export default function defaultLabelStyle(isComponent) {
	return {
		thousandsSeparator: true,
		decimalPlaces: 4,
		displayAsPercentage: isComponent,
		showUnit: true
	};
}
